import { render, staticRenderFns } from "./ManualApi.vue?vue&type=template&id=209a5a74"
import script from "./ManualApi.vue?vue&type=script&lang=js"
export * from "./ManualApi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('209a5a74')) {
      api.createRecord('209a5a74', component.options)
    } else {
      api.reload('209a5a74', component.options)
    }
    module.hot.accept("./ManualApi.vue?vue&type=template&id=209a5a74", function () {
      api.rerender('209a5a74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ManualApi.vue"
export default component.exports